<template>
    <div class="profile-pagination">
        <div class="profile-pagination__result-on-page">
            <template v-if="showRowsPerPageSelection && pagination.rows_count >= 50">
                <span style="font-weight: 400">
                    <span>Результатов на странице</span>
                    <span @click="changeRowsPerPage(50)" :class="{ 'blue-red-hover-text': pagination.rows_per_page != 50 }">50</span>
                    <span @click="changeRowsPerPage(100)" v-if="pagination.rows_count > 50" :class="{ 'blue-red-hover-text': pagination.rows_per_page != 100 }">100</span>
                    <span @click="changeRowsPerPage(250)" v-if="pagination.rows_count > 100" :class="{ 'blue-red-hover-text': pagination.rows_per_page != 250 }">250</span>
                    <span @click="changeRowsPerPage(500)" v-if="pagination.rows_count > 250" :class="{ 'blue-red-hover-text': pagination.rows_per_page != 500 }">500</span>
                    <span @click="changeRowsPerPage(1000)" v-if="pagination.rows_count > 500" :class="{ 'blue-red-hover-text': pagination.rows_per_page != 1000 }">1000</span>
                </span>
            </template>
        </div>
        <div v-if="!isPaginatorHidden" class="profile-pagination__page-turn">
            <span class="profile-pagination__stats">показано {{shownOnPage}} из {{pagination.rows_count}}</span>
            <template v-if="isPagination">
                <span @click="turnPage(pagination.current_page - 1)" :class="{'profile-pagination__page': true, 'profile-pagination__page_active': pagination.current_page > 1}"><i class="lnr lnr-chevron-left"></i></span>
                <template v-if="pagination.current_page > 3">
                    <span @click="turnPage(1)" class="profile-pagination__page profile-pagination__page_active">1</span>
                    <span class="profile-pagination__page">...</span>
                </template>
                <span class="profile-pagination__page profile-pagination__page_active" v-if="pagination.current_page > 2" @click="turnPage(pagination.current_page - 2)">{{pagination.current_page - 2}}</span>
                <span class="profile-pagination__page profile-pagination__page_active" v-if="pagination.current_page > 1" @click="turnPage(pagination.current_page - 1)">{{pagination.current_page - 1}}</span>
                <span class="profile-pagination__page">{{pagination.current_page}}</span>
                <span class="profile-pagination__page profile-pagination__page_active" v-if="pagination.current_page + 1 <= pagination.pages_count" @click="turnPage(pagination.current_page + 1)">{{pagination.current_page + 1}}</span>
                <span class="profile-pagination__page profile-pagination__page_active" v-if="pagination.current_page + 2 <= pagination.pages_count" @click="turnPage(pagination.current_page + 2)">{{pagination.current_page + 2}}</span>
                 <template v-if="pagination.current_page < pagination.pages_count - 2">
                <span class="profile-pagination__page">...</span>
                <span @click="turnPage(pagination.pages_count)" class="profile-pagination__page profile-pagination__page_active">{{pagination.pages_count}}</span>
                </template>
                <span @click="turnPage(pagination.current_page + 1)" :class="{'profile-pagination__page': true, 'profile-pagination__page_active': pagination.current_page < pagination.pages_count}"><i class="lnr lnr-chevron-right"></i></span>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: 'pagination',
    props: {
        // показываем или нет выбор кол-ва на странице
        showRowsPerPageSelection: {
            type: Boolean,
            default: false
        },
        // сам обьект пагинации с апишки
        pagination: Object,
        // коллбек для запроса на апишку из вне
        onTurnPageCallBack: Function,
        // непосредственно кол-во элементов на странице (для последней страницы)
        rows_on_page: Number
    },
    data() {
        return {
            isPagination: true
        }
    },
    methods: {
        turnPage(page) {
            if(page > this.pagination.pages_count || page === 0) { return }
            const offset = this.pagination.rows_per_page * (page - 1)
            this.$props.onTurnPageCallBack(offset, this.$props.pagination.rows_per_page)
        },
        changeRowsPerPage(rows_per_page) {
            this.$props.onTurnPageCallBack(0, rows_per_page)
        },
        hideShowPagination() {
            if(this.pagination.pages_count === 1) {
                this.isPagination = false
            } else {
                this.isPagination = true
            }
        }
    },
    computed: {
        shownOnPage() {
            if(this.$props.rows_on_page) {
                return this.$props.rows_on_page
            } else {
                return this.pagination.rows_count < this.pagination.rows_per_page ? this.pagination.rows_count : this.pagination.rows_per_page
            }
        },
        isPaginatorHidden() { return this.$store.state?.paginator?.isPaginatorHidden }
    },
    mounted() {
        if(this.pagination.rows_count <= 10) {
            this.$store.dispatch('paginator/setPaginatorState', true)
        }
    },
    mounted() { this.hideShowPagination() },
    watch: {
        pagination() { this.hideShowPagination() }
    }
}
</script>

<style lang="sass" scoped>
@import "styles/global-variables"

.full-width
    width: 100% !important

.profile-pagination
    width: 100%
    display: inline-block
    vertical-align: middle
    margin: 5px 0
    font-size: 0
    &__result-on-page, &__page-turn
        display: inline-block
        vertical-align: top
        width: 50%
        font-size: 13px
    &__page-turn
        text-align: right
    &__result-on-page
        text-align: left
    &__stats
        color: #888
        vertical-align: bottom
        font-size: 13px
        margin-right: 15px
    &__page
        cursor: default
        font-size: 16px
        vertical-align: middle
        color: #888
        margin-right: 4px
        .lnr
            font-size: 12px
            font-weight: 600
        &_active
            color: #4771F3
            cursor: pointer
            &:hover 
                color: lighten(#4771F3, 20%)

@media screen and (max-width: $desktop-resolution)
    .profile-pagination
        text-align: left
@media screen and (max-width: $tablet-resolution)
    .profile-pagination__result-on-page-title,
    .profile-pagination__stats
        display: block
@media screen and (max-width: $mobile-resolution)
    .profile-pagination__result-on-page-title,
    .profile-pagination__stats,
    .profile-pagination__page-turn,
    .profile-pagination__result-on-page
        display: block
        width: 100%
    .profile-pagination__page-turn
        text-align: left
        margin: 15px 0
</style>